export default '01.84.80.05.39';
